import { object } from 'common/helpers'


export const initialState = {
  price: 0,
  date: null,
  email: '',
  name: '',
  message: '',
  cardSkins: {
    isFetching: false,
    items: [],
  },
  selectedSkinId: null,
  deliveryType: '',
  gender: 'female',
}

export const setDate = (state, payload) => (
  object.set(state, 'date', payload)
)

export const setPrice = (state, payload) => (
  object.set(state, 'price', payload)
)

export const setCardSkinsFetching = (state, payload) => (
  object.setIn(state, 'cardSkins.isFetching', payload)
)

export const setCardSkins = (state, payload) => (
  object.set(state, 'cardSkins', {
    isFetching: false,
    items: payload,
  })
)

export const setSelectedSkinId = (state, payload) => (
  object.set(state, 'selectedSkinId', payload)
)

export const setDeliveryType  = (state, payload) => (
  object.set(state, 'deliveryType', payload)
)

export const setPerson = (state, { name, email, message }) => (
  object.merge(state, { name, email, message })
)

export const reset = () => initialState
